import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

interface DeleteProductDialogProps {
  open: boolean
  productName: string
  onConfirm: () => void
  onCancel: () => void
}

const DeleteProductDialog = ({
  open,
  productName,
  onConfirm,
  onCancel,
}: DeleteProductDialogProps) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>Delete Product</DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        Are you sure you want to delete <strong>{productName}</strong>? This action cannot be
        undone.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
      <Button variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="contained" color="error" onClick={onConfirm}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
)

export default DeleteProductDialog
